var app = angular.module('leonardo');

var ScoreStars = function() {
  return {
    restrict: 'A',
    scope: {
      onlyRead: '=?',
      score: '=',
      numberStars: '=?'
    },
    templateUrl: 'views/templates/form/score-stars.html',
    link: function (scope) {

      scope.getNumber = function(num) {
        return new Array(num);
      };

      scope.score = scope.score ? scope.score : undefined;

      scope.stars = scope.numberStars ? scope.getNumber(scope.numberStars) : scope.getNumber(5);

      scope.getClasses = function (index) {
        if ((scope.score >= index && scope.score == scope.score_aux) || (scope.score_aux >= index)) {
          return 'active';
        }
        return '';
      };

      scope.setScore = function (value) {
        scope.score = value;
      };

      scope.setScoreAux = function (value) {
        scope.score_aux = value;
      };

      scope.$watch('score', function (value) {
        scope.score_aux = value;
      });

      scope.initScore = function () {
        scope.score_aux = scope.score;
      };

      scope.$watch('numberStars', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          scope.stars = newValue ? scope.getNumber(newValue) : scope.getNumber(5);
        }
      });

    }
  };
};

app.directive('scoreStars', [ScoreStars]);